import { useState } from "react";
import { DownloadOutlined } from "@ant-design/icons";
import {
  DatePicker,
  Select,
  InputNumber,
  Button,
  Image,
  Form,
  Typography,
  Card,
  Slider,
  Checkbox,
  Rate,
  Row,
  Col,
  Divider,
  Flex,
} from "antd";
import dayjs from "dayjs";
import "antd/dist/reset.css"; // reset antd styles
import cruiseBg from "../assets/images/listOfCruise.jpg";
import cruiseCardImg from "../assets/images/cruiseCardImg.jpg";

import PriceRangeDropdown from "../components/PriceRangeDropdown.jsx";
import RoomsGuestsDropdown from "../components/RoomsGuestsDropdown.jsx";
import CustomDateRange from "../components/CustomDateRange.jsx";
import sliderImg from "../assets/images/bannerHotel.jpg";
import TravelMonthSelector from "../components/TravelMonthSelector.jsx";
import TravelMonthDropdown from "../components/TravelMonthSelector.jsx";

import { CloseOutlined } from "@ant-design/icons";
import CruiseCard from "../components/CruiseCard.jsx";

const { RangePicker } = DatePicker;
const { Option } = Select;
const { Text, Paragraph } = Typography;

const filters = ["Cruise Date", "Destination", "Duration", "Price", "Ship"];

const FilterTags = () => {
  return (
    <div className="flex flex-wrap gap-3 items-center mt-8">
      {filters.map((filter) => (
        <Button
          key={filter}
          shape="round"
          size=""
          className="flex-1 text-sm font-semibold flex items-center justify-between gap-2 border-0 hover:bg-gray-200 px-4 py-6"
        >
          <span>{filter}</span>
          <CloseOutlined className="text-xs" />
        </Button>
      ))}
    </div>
  );
};

const cruises = [
  {
    id: 1,
    title: "3N Desert & Sea Voyage Abu Dhabi - Sir Bani Yas - Dubai",
    price: "INR 1,43,200",
    oldPrice: "INR 2,65,185",
    savings: "INR 1,21,985",
    departure: "Doha, Qatar",
    dates: "January 2027 - February 2027",
    rating: 4.9,
    reviews: 523,
    image: cruiseCardImg,
  },
];

export default function CruiseListPage() {
  const [formData, setFormData] = useState({
    country: "UAE",
    city: "Dubai",
    checkIn: dayjs("2025-08-10"),
    checkOut: dayjs("2025-08-11"),
    rooms: 1,
    guests: 2,
    price: [2500, 5000],
  });

  const [priceRange, setPriceRange] = useState([4650, 57260]);

  return (
    <>
      <div className="relative min-h-[100%] bg-cover bg-center flex items-end gap-6 justify-center">
        <Image
          src={cruiseBg}
          alt="Slide 1"
          className="w-full !h-full object-cover"
          preview={false}
        />

        <div className="container absolute z-10 pb-8">
          {/* White Card */}
          <div className=" bg-white shadow-[0px_4px_6px_1px_rgba(0,0,0,0.25)] rounded-2xl p-6">
            {/* Heading */}
            {/* <h2 className="text-2xl font-semibold mb-2">
            Hotels You <span className="text-danger">Love</span>, Prices You’ll{" "}
            <span className="text-primary">Adore</span>
          </h2>
          <p className="font-normal mt-1">
            Culture, nature, thrills, and record-breaking experiences
          </p> */}

            <Form
              layout="vertical"
              className="grid grid-cols-4 gap-4  rounded-md bg-white  px-4"
            >
              {/* Country */}
              <Form.Item
                name="country"
                label="Select Country"
                className="col-span-1 m-0 font-medium border-r py-4"
              >
                <Select
                  defaultValue={formData.country}
                  bordered={false}
                  size="large"
                  className="w-full custom-select text-primary"
                >
                  <Option value="UAE">UAE</Option>
                  <Option value="Thailand">Thailand</Option>
                  <Option value="USA">USA</Option>
                  <Option value="France">France</Option>
                </Select>
              </Form.Item>

              {/* City */}
              <Form.Item
                name="city"
                label="Select City"
                className="font-medium col-span-1 m-0 py-4 border-r"
              >
                <Select
                  defaultValue={formData.city}
                  bordered={false}
                  size="large"
                  className="w-full custom-select text-danger"
                >
                  <Option value="Dubai">Dubai</Option>
                  <Option value="Bangkok">Bangkok</Option>
                  <Option value="New York">New York</Option>
                  <Option value="Paris">Paris</Option>
                </Select>
              </Form.Item>

              {/* Rooms & Guests */}
              <Form.Item
                label=""
                className="col-span-1 m-0 font-medium py-4 border-r"
              >
                <TravelMonthDropdown />
              </Form.Item>
              {/* Button */}
              <div className="text-center col-span-1 mt-8 mb-[-55px]">
                <Button
                  type="danger"
                  size="middle"
                  className="rounded-full w-3/4 py-7 shadow-md text-xl font-medium flex-1 
             bg-danger hover:bg-red-700 border-none 
             text-white"
                >
                  Search
                </Button>
              </div>
            </Form>
          </div>
          <FilterTags />
        </div>
      </div>

      <div className="p-6 container">
        {/* Header */}
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-lg font-semibold text-primary">
            2659 Properties in <span className="text-danger">Goa</span>
          </h2>
          <div className="flex items-center gap-4">
            <span className="font-medium text-gray-600">Sort By:</span>
            <Button size="small" type="text" className="text-blue-600">
              Price Low to High
            </Button>
            <Button size="small" type="text" className="text-blue-600">
              Price High to Low
            </Button>
          </div>
        </div>

        {/* Main Layout */}
        <div className="border border-[#CCE1F9]">
          <Row gutter={[40, 40]}>
            {/* Left Section - Cards */}
            <Col xs={24} md={17} lg={18} className="border-r border-[#CCE1F9]">
              <Row gutter={[16, 16]} className="p-4 pr-0">
                {Array(6)
                  .fill(cruises[0])
                  .map((item, index) => (
                    <Col xs={24} sm={12} md={12} lg={12} key={index}>
                      <CruiseCard cruiseDetail={item} />
                    </Col>
                  ))}
              </Row>
            </Col>

            {/* Right Section - Filters */}
            <Col xs={24} md={7} lg={6} className="filterForm">
              <div className="w-full pr-4 py-4">
                <h3 className="font-semibold mb-3">
                  Customize Search
                </h3>

                <Select
                  placeholder="Destination (Any)"
                  className="w-full mb-2"
                />
                <Select
                  placeholder="Cruise Length (Any)"
                  className="w-full mb-2"
                />
                <Select
                  placeholder="Departure Date (Any)"
                  className="w-full mb-2"
                />
                <Select
                  placeholder="Cruise Line (Any)"
                  className="w-full mb-2"
                />
                <Select
                  placeholder="Cruise Ship (Any)"
                  className="w-full mb-2"
                />
                <Select placeholder="Departure Port (Any)" className="w-full" />

                <h4 className="font-semibold mt-5 mb-3">Price</h4>
                <Slider
                  range
                  min={4650}
                  max={57260}
                  value={priceRange}
                  onChange={setPriceRange}
                  className="mt-2"
                />
                <Flex
                  justify="space-between"
                  className="text-xs font-medium mb-4"
                >
                  <span>AED{priceRange[0]}</span>{" "}
                  <span>AED{priceRange[1]}</span>
                </Flex>

                <h4 className="font-semibold mt-5 mb-3">Package Category</h4>
                <Checkbox className="">Family Cruise</Checkbox>

                <h4 className="font-semibold mt-5 mb-3">Package Nights</h4>
                <div className="flex flex-col space-y-1">
                  <Checkbox>3 nights</Checkbox>
                  <Checkbox>4 nights</Checkbox>
                  <Checkbox>7 nights</Checkbox>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </>
  );
}
